import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const NAV_ITEMS = [
  {
    path: '/',
    label: 'Home',
    match: (pathname) => pathname === '/',
    Icon: IconHome,
  },
  {
    path: '/matches',
    label: 'Partite',
    match: (pathname) => pathname === '/matches' || pathname.startsWith('/matches/'),
    Icon: IconMatches,
  },
  {
    path: '/groups',
    label: 'Gruppi',
    match: (pathname) => pathname.startsWith('/groups'),
    Icon: IconGroups,
  },
  {
    path: '/profile',
    label: 'Profilo',
    match: (pathname) => pathname === '/profile' || pathname.startsWith('/profile/'),
    Icon: IconProfile,
  },
];

function IconHome({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
      <path d="M3 10.5 12 3l9 7.5V20a1 1 0 0 1-1 1h-5v-6H9v6H4a1 1 0 0 1-1-1v-9.5Z" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function IconMatches({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
      <path d="M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function IconGroups({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" strokeLinecap="round" />
      <circle cx="9" cy="7" r="4" />
      <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" strokeLinecap="round" />
    </svg>
  );
}

function IconProfile({ className }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden>
      <circle cx="12" cy="8" r="4" />
      <path d="M4 20a8 8 0 0 1 16 0" strokeLinecap="round" />
    </svg>
  );
}

export default function BottomNav() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-[100] flex h-[60px] items-stretch border-t border-[rgba(56,189,248,0.15)] bg-[#0A2A6E] px-1"
      role="navigation"
      aria-label="Navigazione principale"
    >
      {NAV_ITEMS.map(({ path, label, match, Icon }) => {
        const active = match(pathname);
        return (
          <button
            key={path}
            type="button"
            onClick={() => navigate(path)}
            className="flex flex-1 flex-col items-center justify-center gap-0.5 py-1 text-[11px] font-medium transition-colors"
            style={{ color: active ? '#38BDF8' : '#475569' }}
            aria-current={active ? 'page' : undefined}
          >
            <Icon className="h-6 w-6 shrink-0" />
            <span>{label}</span>
          </button>
        );
      })}
    </nav>
  );
}
